import { Component} from '@angular/core';

@Component({
    selector: 'ivr-donation-user-task-main',
    templateUrl: './ivr-donation-user-task-main.tmpl.html'
})

export class IvrDonationUserTaskMain {  
}
  